import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { AdmissionCreateScreen } from 'screens/patient';

export default withPermissions(AdmissionCreateScreen, [
  GroupSecurity.EncounterCreate,
]);
